const redis = window.electronLibs.redis;

export const subscribeRedisPubsub = async (accountId: string, branchId: string) => {
  await redis.subscribePubsub(accountId, branchId);
};

export const unSubscribeRedisPubsub = async (accountId: string, branchId: string) => {
  await redis.unSubscribePubsub(accountId, branchId);
};
export const getRedisClient = async (accountId: string, branchId: string): Promise<any> => {
  return await redis.getRedisClient(accountId, branchId);
};

export const checkSubscriberPubsubHealth = async (accountId: string, branchId: string) => {
  return await redis.checkSubscriberPubsubHealth(accountId, branchId);
};
